import React from "react";
import "./Scan.css";
import Header from "../scan/header/Header";
import Sidebar from "../operator_home/sidebar/Sidebar";
import ScanScreen from "../scan/main/ScanScreen";

const Scan = () => {
  return (
    <main className="scan-page-container">
      <Header />
      <Sidebar />
      <ScanScreen />
    </main>
  );
};

export default Scan;
